/**
 * Hero background color mappings.
 * Maps color identifiers to CSS class names for light and dark backgrounds.
 */
export const HERO_LIGHT_BACKGROUND_COLORS = new Map<string, string>([
    ['default', 'sir-light-gradient-cool-neutral-2'],
    ['lgurblue', 'sir-light-gradient-ur-blue'],
    ['lgcoolneutral1', 'sir-light-gradient-cool-neutral-1'],
    ['lgcoolneutral2', 'sir-light-gradient-cool-neutral-2'],
    ['lgwarmneutral1', 'sir-light-gradient-warm-neutral-1'],
    ['lgwarmneutral2', 'sir-light-gradient-warm-neutral-2'],
    ['lsurblue', 'sir-light-solid-ur-blue'],
    ['lscoolneutral1', 'sir-light-solid-cool-neutral-1'],
    ['lscoolneutral2', 'sir-light-solid-cool-neutral-2'],
    ['lswarmneutral1', 'sir-light-solid-warm-neutral-1'],
    ['lswarmneutral2', 'sir-light-solid-warm-neutral-2'],
] as const);

export const HERO_DARK_BACKGROUND_COLORS = new Map<string, string>([
    ['dgurbluedark', 'sir-dark-gradient-ur-blue-dark'],
    ['dgurblack', 'sir-dark-gradient-ur-black'],
    ['dsurblack', 'sir-dark-solid-ur-black'],
    ['dsuraccent', 'sir-dark-solid-ur-accent'],
    ['dsurdarkblue1', 'sir-dark-solid-ur-dark-blue-1'],
    ['dsurdarkblue2', 'sir-dark-solid-ur-dark-blue-2'],
] as const);

/**
 * Determines if a color identifier belongs to a light background.
 */
export function isLightBackgroundColor(color: string): boolean {
    return HERO_LIGHT_BACKGROUND_COLORS.has(color || 'default');
}

/**
 * Gets the CSS class name for a given color identifier.
 * Returns undefined if the color is not found.
 */
export function getBackgroundColorClass(color: string, isLight: boolean): string | undefined {
    return isLight ? HERO_LIGHT_BACKGROUND_COLORS.get(color) : HERO_DARK_BACKGROUND_COLORS.get(color);
}
